module.exports = __webpack_public_path__ + "static/media/81.c661e053.png";